import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { useGeneralParams } from "@hooks/useGeneralParams";
import { DEBUG_MODE } from "@utils/config";
import { handleApiError } from "@utils/errorHandler";
import companyActiveIcon from "@icons/company-active.svg";
import companyLogo from "@icons/Company.svg";
import settingIcon from "@icons/settings.svg";
import settingActiveIcon from "@icons/settings-active.svg";
import reportingIcon from "@icons/reporting.svg";
import reportingActiveIcon from "@icons/reporting-active.svg";
import leadIcon from "@icons/leads.svg";
import mapActiveIcon from "@icons/map-active-icon.svg";
import leadActiveIcon from "@icons/leads-active.svg";
import meetingIcon from "@icons/meeting.svg";
import meetingActiveIcon from "@icons/meeting-active.svg";
import notificationIcon from "@icons/notifications.svg";
import notificationActiveIcon from "@icons/notifications-active.svg";
import productIcon from "@icons/products.svg";
import productActiveIcon from "@icons/products-active.svg";
import siteIcon from "@icons/sites.svg";
import siteActiveIcon from "@icons/sites-active.svg";
import contactIcon from "@icons/contacts.svg";
import contactActiveIcon from "@icons/contacts-active.svg";
import dashboardIcon from "@icons/Dashboard.svg";
import closeIcon from "@icons/ic-close-white.svg";
import homeIcon from "@icons/ic-home.svg";
import quoteIcon from "@icons/ic-quote.svg";
import quoteIconActive from "@icons/ic-quote-active.svg";
import LanguageSelection from "./components/LanguageSelection/LanguageSelection";
import CompanyMenu from "./components/CompanyMenu/CompanyMenu";
import SiteMenu from "./components/SiteMenu/SiteMenu";
import AdminMenu from "./components/AdminMenu/AdminMenu";
import EnquiryMenu from "./components/EnquiryMenu/EnquiryMenu";
import PlanningMenu from "./components/PlanningMenu/PlanningMenu";
import ReportingMenu from "./components/ReportingMenu/ReportingMenu";
import MyAccount from "./components/MyAccount/MyAccount";
import planningIcon from "@icons/ic-planning-white.svg";
import planningActiveIcon from "@icons/ic-planning-menu.svg";
import invoiceIcon from "@icons/ic-invoice-white.svg";
import invoiceActiveIcon from "@icons/ic-invoice-menu.svg";
import { languageFlagPathArray } from "@utils/constants";
import defaultFlag from "@icons/flags/ic-default-flag.png";
import UserInfo from "@utils/UserInfo";
import "./NavBar.scss";

const NavBar = (props) => {
  const { t } = props;

  const initLng = i18next.language;
  const languageList = JSON.parse(localStorage.getItem("language_list"));
  const countryInfo = UserInfo.countryInfo();


  // Get user details from localStorage (JWT auth) or fallback to window (session auth)
  const getUserDetails = () => {
    const parsed = UserInfo.getUser();
    if (parsed) {
      try {
        return {
          id: parsed.id,
          first_name: parsed.firstName,
          last_name: parsed.lastName,
          tech_admin: parsed.techAdmin,
          job: parsed.job,
          phone: parsed.phone,
        };
      } catch (e) {
        return {};
      }
    }
    return {};
  };

  const userDetails = getUserDetails();
  const token = [];
  const logOut = [];
  const history = useNavigate();

  const location = useLocation();

  const [activeLink, setActiveLink] = useState(location.pathname);
  const [showMyAccountPopup, setShowMyAccountPopup] = useState(false);
  const symfonyLink = ["/logout", "/groups", "/transport", "/jobsite/map"];

  const { fetchGeneralParams } = useGeneralParams();

  // const setActiveLinkName = () => {
  //   setActiveLink(window.location.pathname);
  // };

  // useEffect(() => {
  //   setActiveLinkName();
  // }, []);

  // if (window.location.pathname !== activeLink) {
  //   setActiveLink(window.location.pathname);
  // }

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const handleLogout = () => {
    // Clear JWT tokens from localStorage
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token_expires_in");
    localStorage.removeItem("user_info");
    localStorage.removeItem("language_list");
    // Redirect to login page
    window.location.href = "/login";
  };

  const handleNavItemClick = (e) => {
    const link = e.target.dataset.link || e.currentTarget.dataset.link;

    // Handle logout separately
    if (link === "/logout") {
      handleLogout();
      return;
    }

    if (symfonyLink.includes(link)) window.location.href = link;

    // $("#sidebar, #content").removeClass("active");
    if (link === "/login") {
      logOut(token);
    }
    setActiveLink(link);
    history(link);
  };

  const handleContextMenu = (e) => {
    const link = e.target.dataset.link || e.currentTarget.dataset.link;

    // Handle logout separately
    if (link === "/logout") {
      handleLogout();
      return;
    }

    if (symfonyLink.includes(link)) window.location.href = link;

    // $("#sidebar, #content").removeClass("active");
    if (link === "/login") {
      logOut(token);
    }
    setActiveLink(link);
    window.open(link, "_blank");
  };

  const fetchLanguageList = () => {
    axios
      .get(`/language_list`, {
        headers: { Accept: "application/json" },
      })
      .then((response) => {
        const langArray = [];
        response.data?.map((langInfo) => {
          langArray.push({
            id: langInfo.id,
            lang: langInfo.locale,
            flag: languageFlagPathArray[langInfo.id]
              ? languageFlagPathArray[langInfo.id]
              : defaultFlag,
            title: langInfo.name,
          });
        });
        setLanguages([...langArray]);
        localStorage.setItem("language_list", JSON.stringify([...langArray]));
      })
      .catch((error) => handleApiError(error));
  };
  useEffect(() => {
    if (
      !localStorage.getItem("locale") ||
      localStorage.getItem("locale") === null
    ) {
      i18next.changeLanguage(initLng).then(() => {
        if (DEBUG_MODE) {
          // eslint-disable-next-line no-console
          console.info("Nav List: language changed successfully");
        }
      });
    }
    if (languageList?.length === 0) {
      fetchLanguageList();
    }
  }, []);

  const handleReportingClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setActiveLink("/report/view");
  };


  return (
    <nav id="sidebar" className="active">
      <div className="sidebar__mobile-header">
        <div
          data-link="/dashboard"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          role="button"
          tabIndex="0"
        >
          <Image src={companyLogo} alt="Logo icon" data-link="/dashboard" />
        </div>
        <Image
          src={closeIcon}
          alt="Close icon"
          className="sidebar__mobile-header-close"
        />
      </div>
      <div className="sidebar__menu-header">
        <div className="sidebar__menu-header-item">
          <div>
            <Image
              src={homeIcon}
              width="45"
              height="45"
              alt="logo"
              data-link="/"
            />
          </div>
          <div className="action-group">
            <div className="dropdown">
              <button
                className="my-account-btn fontLato14 rounded-circle mr-2 dropdown-toggle"
                id="profileDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                type="button"
              >
                {Object.prototype.hasOwnProperty.call(
                  userDetails,
                  "first_name"
                ) && (
                  <span>
                    {userDetails.first_name
                      ? userDetails.first_name.split("")[0]
                      : ""}
                    {userDetails.last_name
                      ? userDetails.last_name.split("")[0]
                      : ""}
                    {!userDetails.first_name && !userDetails.last_name && (
                      <i
                        className="fa fa-user default-user"
                        aria-hidden="true"
                      />
                    )}
                  </span>
                )}
              </button>
              <div
                className="signout dropdown-menu dropdown-menu-right dropdown-menu-my-account text-nowrap "
                aria-labelledby="profileDropdown"
              >
                <ul className="nav navbar-nav navbar-nav-my-account ml-auto d-none d-md-flex">
                  <li
                    onClick={() => setShowMyAccountPopup(true)}
                    className="d-block px-2 py-1 my-account-menu-text"
                    style={{ cursor: "pointer" }}
                  >
                    {/* <i className="fa fa-user pr-1" aria-hidden="true" />{" "} */}
                    {t("MENU_MY_ACCOUNT")}
                  </li>
                  <li
                    data-link="/logout"
                    onClick={handleNavItemClick}
                    onContextMenu={handleContextMenu}
                    className="d-block px-2 py-1 my-account-menu-text"
                  >
                    <i className="fa fa-sign-out pr-1" aria-hidden="true" />
                    {t("MENU_LOGOUT")}
                  </li>
                </ul>
              </div>
            </div>
            {showMyAccountPopup && (
              <MyAccount
                userDetails={userDetails}
                onClose={() => setShowMyAccountPopup(false)}
                onUpdateSuccess={() => {
                  // Refresh user details after update
                  fetchGeneralParams();
                }}
              />
            )}
            {languageList?.length > 0 && (
              <LanguageSelection languageList={languageList} />
            )}
          </div>
        </div>
      </div>
      <ul className="sidebar__menu-list">
        <li
          data-link="/"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={activeLink === "/" ? "nav-link active" : "nav-link"}
            data-link="/"
          >
            <Image
              src={dashboardIcon}
              width="25"
              height="25"
              alt="logo"
              data-link="/"
            />
            <span className="menu-pad" data-link="/">
              {t("MENU_DASHBOARD")}
            </span>
          </div>
        </li>
        <li
          data-link="/company/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/company/list" ? "nav-link active" : "nav-link"
            }
            data-link="/company/list"
          >
            <Image
              src={
                activeLink === "/company/list" ? companyActiveIcon : companyLogo
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/company/list"
            />
            <span className="menu-pad" data-link="/company/list">
              {t("MENU_COMPANIES")}
            </span>
          </div>
          {activeLink.slice(0, 13) === "/company/view" && (
            <CompanyMenu
              handleNavItemClick={handleNavItemClick}
              handleContextMenu={handleContextMenu}
            />
          )}
        </li>

        <li
          data-link="/contact/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/contact/list" ? "nav-link active" : "nav-link"
            }
            data-link="/contact/list"
          >
            <Image
              src={
                activeLink === "/contact/list" ? contactActiveIcon : contactIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/contact/list"
            />
            <span className="menu-pad" data-link="/contact/list">
              {t("MENU_CONTACTS")}
            </span>
          </div>
        </li>
        <li
          data-link="/site/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/site/list" ? "nav-link active" : "nav-link"
            }
            data-link="/site/list"
          >
            <Image
              src={activeLink === "/site/list" ? siteActiveIcon : siteIcon}
              width="25"
              height="25"
              alt="logo"
              data-link="/site/list"
            />
            <span className="menu-pad" data-link="/site/list">
              {t("MENU_SITES")}
            </span>
          </div>
          {activeLink.slice(0, 10) === "/site/view" && (
            <SiteMenu
              handleNavItemClick={handleNavItemClick}
              handleContextMenu={handleContextMenu}
            />
          )}
        </li>

        <li
          data-link="/request/list/all"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/request/list/all"
                ? "nav-link active"
                : "nav-link"
            }
            data-link="/request/list/all"
          >
            <Image
              src={
                activeLink === "/request/list/all"
                  ? productActiveIcon
                  : productIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/request/list/all"
            />
            <span className="menu-pad" data-link="/request/list/all">
              {t("MENU_ENQUIRIES")}
            </span>
          </div>
          <EnquiryMenu
            handleNavItemClick={handleNavItemClick}
            handleContextMenu={handleContextMenu}
            activeLink={activeLink}
          />
        </li>

        <li
          data-link="/quote/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/quote/list" ? "nav-link active" : "nav-link"
            }
            data-link="/quote/list"
          >
            <Image
              src={activeLink === "/quote/list" ? quoteIconActive : quoteIcon}
              width="25"
              height="25"
              alt="logo"
              data-link="/quote/list"
            />
            <span className="menu-pad" data-link="/quote/list">
              {t("MENU_QUOTES")}
            </span>
          </div>
        </li>

        {countryInfo.country.needKickoff === 1 && (
          <li
            data-link="/kickoff/list"
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
          >
            <div
              className={
                activeLink === "/kickoff/list" ? "nav-link active" : "nav-link"
              }
              data-link="/kickoff/list"
            >
              <Image
                src={
                  activeLink === "/kickoff/list"
                    ? notificationActiveIcon
                    : notificationIcon
                }
                width="25"
                height="25"
                alt="logo"
                data-link="/kickoff/list"
              />
              <span className="menu-pad" data-link="/kickoff/list">
                {t("MENU_KICKOFFS")}
              </span>
            </div>
          </li>
        )}

        <li
          data-link="/planning/orders"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink.slice(0, 10) === "/planning/"
                ? "nav-link active"
                : "nav-link"
            }
            data-link="/planning/orders"
          >
            <Image
              src={
                activeLink.slice(0, 10) === "/planning/"
                  ? planningActiveIcon
                  : planningIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/planning/orders"
            />
            <span className="menu-pad" data-link="/planning/orders">
              {t("MENU_PLANNING")}
            </span>
          </div>

          <PlanningMenu
            handleNavItemClick={handleNavItemClick}
            handleContextMenu={handleContextMenu}
          />
        </li>
        <li
          data-link="/invoice/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/invoice/list" ? "nav-link active" : "nav-link"
            }
            data-link="/invoice/list"
          >
            <Image
              src={
                activeLink === "/invoice/list" ? invoiceActiveIcon : invoiceIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/invoice/list"
            />
            <span className="menu-pad" data-link="/invoice/list">
              {t("MENU_CLIENT_INVOICING")}
            </span>
          </div>
        </li>

        <li
          data-link="/meeting_report"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/meeting_report" ? "nav-link active" : "nav-link"
            }
            data-link="/meeting_report"
          >
            <Image
              src={
                activeLink === "/meeting_report"
                  ? meetingActiveIcon
                  : meetingIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/meeting_report"
            />
            <span className="menu-pad" data-link="/meeting_report">
              {t("MENU_MEETING_REPORTS")}
            </span>
          </div>
        </li>

        <li
          data-link="/lead/list"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/lead/list" ? "nav-link active" : "nav-link"
            }
            data-link="/lead/list"
          >
            <Image
              src={activeLink === "/lead/list" ? leadActiveIcon : leadIcon}
              width="25"
              height="25"
              alt="logo"
              data-link="/lead/list"
            />
            <span className="menu-pad" data-link="/lead/list">
              {t("MENU_LEADS")}
            </span>
          </div>
        </li>
        <li
          data-link="/general/map"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink === "/general/map" ? "nav-link active" : "nav-link"
            }
            data-link="/general/map"
          >
            <Image
              src={
                activeLink === "/general/map" ? mapActiveIcon : mapActiveIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/general/map"
            />
            <span className="menu-pad" data-link="/general/map">
              {t("MENU_MAP")}
            </span>
          </div>
        </li>

        <li
          data-link="/report/view"
          onClick={handleReportingClick}
          onContextMenu={handleContextMenu}
        >
          <div
            className={
              activeLink.slice(0, 7) === "/report"
                ? "nav-link active"
                : "nav-link"
            }
            data-link="/report/view"
          >
            <Image
              src={
                activeLink.slice(0, 7) === "/report"
                  ? reportingActiveIcon
                  : reportingIcon
              }
              width="25"
              height="25"
              alt="logo"
              data-link="/report/view"
            />
            <span className="menu-pad" data-link="/report/view">
              {t("MENU_REPORTING")}
            </span>
          </div>

          <ReportingMenu
            isOpen={activeLink.slice(0, 7) === "/report"}
            handleNavItemClick={handleNavItemClick}
            handleContextMenu={handleContextMenu}
          />
        </li>

        {userDetails?.tech_admin && (
          <li
            data-link="/administration/manager"
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
          >
            <div
              className={
                activeLink === "admin" ? "nav-link active" : "nav-link"
              }
              data-link="/administration/manager"
            >
              <Image
                src={
                  activeLink.slice(0, 15) === "/administration"
                    ? settingActiveIcon
                    : settingIcon
                }
                width="25"
                height="25"
                alt="logo"
                data-link="/administration/manager"
              />
              <span className="menu-pad" data-link="/administration/manager">
                {t("MENU_ADMINISTRATION")}
              </span>
            </div>

            {activeLink.slice(0, 15) === "/administration" && (
              <AdminMenu
                handleNavItemClick={handleNavItemClick}
                handleContextMenu={handleContextMenu}
              />
            )}
          </li>
        )}
      </ul>
    </nav>
  );
};

NavBar.propTypes = {
  // token: PropTypes.string.isRequired,
  // userDetails: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // isCallOfOrder: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  // logOut: PropTypes.func.isRequired,
};

export default withTranslation()(NavBar);
